export default __webpack_public_path__ + "static/media/icon-close.3ef5d26f.svg";